import { render } from "./Synergy.vue?vue&type=template&id=847187d0"
import script from "./Synergy.vue?vue&type=script&lang=js"
export * from "./Synergy.vue?vue&type=script&lang=js"

import "./Synergy.vue?vue&type=style&index=0&id=847187d0&lang=scss"

import exportComponent from "D:\\Code\\word\\anyRTC\\anyrtc_synergy\\Synergy-Experts\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__